import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewEncapsulation} from '@angular/core';
import {NavigationEvent, MonthViewModel} from './datepicker-view.model';
import {DbDate} from './db-date';
import {DbDatepickerI18n} from './datepicker-i18n';

@Component({
    selector: 'db-datepicker-navigation',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./datepicker-navigation.scss'],
    template: `
    <a class="db-datepicker__arrow" [ngClass]="{'disabled': prevDisabled}" (click)="onClickPrev($event)">
      <i class="db-icon db-icon-ds-arrow-small"></i>
    </a>

    <ng-template ngFor let-month [ngForOf]="months" let-i="index">
      <div *ngIf="i > 0"></div>
      <div class="db-datepicker__month-name">
        {{ i18n.getMonthLabel(month.firstDate) }}
      </div>
      <div *ngIf="i !== months.length - 1"></div>
    </ng-template>
    <a type="button" class="db-datepicker__arrow right"  [ngClass]="{'disabled': nextDisabled}" (click)="onClickNext($event)">
      <i class="db-icon db-icon-ds-arrow-small"></i>
    </a>
  `,
    standalone: false
})
export class DbDatepickerNavigationComponent {
  navigation = NavigationEvent;

  @Input() date: DbDate;
  @Input() disabled: boolean;
  @Input() months: MonthViewModel[] = [];
  @Input() prevDisabled: boolean;
  @Input() nextDisabled: boolean;
  @Input() selectBoxes: { years: number[], months: number[] };

  @Output() navigate = new EventEmitter<NavigationEvent>();
  @Output() select = new EventEmitter<DbDate>();

  constructor(public i18n: DbDatepickerI18n) {
  }

  onClickPrev(event: MouseEvent) {
    (event.currentTarget as HTMLElement).focus();
    this.navigate.emit(this.navigation.PREV);
  }

  onClickNext(event: MouseEvent) {
    (event.currentTarget as HTMLElement).focus();
    this.navigate.emit(this.navigation.NEXT);
  }
}
